import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { IconButton, styled } from "@mui/material";
import clsx from "clsx";
import { NormalText } from "components";
import PropTypes from "prop-types";

const TreeNodeStyled = styled("div")({
  display: "flex",
  alignItems: "center",
  "& .expand-icon": {
    padding: 0,
  },
  "& input": {
    cursor: "pointer",
    "&.no-children": {
      marginLeft: "1rem",
    },
    "&.space-right": {
      marginRight: "0.5rem",
    },
  },
  "& p": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowX: "hidden",
    "&.space-left": {
      marginLeft: "1rem",
    },
  },
});

const TreeNode = ({
  node,
  onToggle,
  onCheck,
  isChecked,
  isDisabled,
  className,
  classNames = {}, // Expected classNames: node,nodeButton,nodeInput,nodeText
}) => {
  const hasChildren = node.children && node.children.length > 0;
  const level = node.parentIdPath?.length ?? 0;
  const isCheckable = Boolean(onCheck);

  return (
    <TreeNodeStyled
      className={clsx(className, classNames.node)}
      sx={{ paddingLeft: `${level * 20}px` }}
    >
      {hasChildren && (
        <IconButton
          size="small"
          className={clsx("expand-icon", classNames.nodeButton)}
          onClick={() => onToggle(node)}
        >
          {node.isExpanded ? (
            <ExpandLess fontSize="small" />
          ) : (
            <ExpandMore fontSize="small" />
          )}
        </IconButton>
      )}
      {isCheckable && (
        <input
          type="checkbox"
          disabled={isDisabled}
          checked={isChecked}
          onChange={() => onCheck(node)}
          className={clsx(
            { "no-children": !hasChildren, "space-right": isCheckable },
            classNames.nodeInput
          )}
        />
      )}
      <NormalText
        className={clsx({ "space-left": !hasChildren }, classNames.nodeText)}
      >
        {node.label}
      </NormalText>
    </TreeNodeStyled>
  );
};

export default TreeNode;

const nodePropType = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  parentIdPath: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  isExpanded: PropTypes.bool,
};
nodePropType.children = PropTypes.arrayOf(PropTypes.shape(nodePropType));

export const treeNodePropType = {
  node: PropTypes.shape(nodePropType),
  onToggle: PropTypes.func,
  onCheck: PropTypes.func,
  isDisabled: PropTypes.bool,
  checkedNodes: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  style: PropTypes.object,
};

TreeNode.propTypes = treeNodePropType;
